<template>
  <Table :headers="headers" :records="records" no-pagination>
    <template #data-price="{ record }">
      <span v-if="record.discountedPrice > 0">{{ record.discountedPrice|money }} <small class="old-price">{{ record.price | money }}</small></span>
      <span v-else>{{ record.price|money }}</span>
    </template>
    <template #data-stock="{ record }">
      <span v-if="record.stock_visible == '1' && record.allow_backorders == '0'">{{ record.stock }}</span>
      <Pill v-else-if="record.allow_backorders == '1' && record.stock < 1">Op bestelling</Pill>
      <span v-else-if="record.stock_visible == '1' && record.allow_backorders == '1' && record.stock > 0">{{ record.stock }}</span>
      <span v-else></span>
    </template>
    <template #data-action="{ record }">
      <AddToCart :noRedirect="noRedirect ? true : false" :data="{ variant: record, product }" v-if="user && selectedUser && record.stock > 0 || record.allow_backorders == '1' || record.allow_backorders == 1" quantityPicker :quantityMax="record.allow_backorders == '1' ? false : record.stock" webshop :category="category" @itemAdded="$emit('itemAdded')" />
      <Pill v-else-if="record.stock < 1">{{ $t('webshop.no_stock') }}</Pill>
      <UserSelect v-else-if="user && !selectedUser" />
      <Pill @click="$router.push({ name: 'Login', query: { redirect: $route.path }})" v-else danger>{{ $t('webshop.login') }}</Pill>
    </template>
  </Table>
</template>

<script>
import Table from '../../components/Table/Index.vue'
import Pill from '../Core/Pill.vue'
import AddToCart from '../Cart/AddToCart.vue'
import UserSelect from '../Core/UserSelect.vue'
export default {
  name: 'WebshopVariationTable',
  components: {
    Table,
    Pill,
    AddToCart,
    UserSelect
  },
  props: {
    headers: Object,
    records: Array,
    noRedirect: Boolean,
    product: Object,
    category: String
  },
  computed: {
    user () {
      return this.$store.getters['user/user']
    },
    selectedUser () {
      return this.$store.getters['user/selectedUser']
    }
  }
}
</script>
